const CompanyTypes = {
  GET_COMPANY_LIST_REQUEST: 'GET_COMPANY_LIST_REQUEST',
  GET_COMPANY_LIST_SUCCESS: 'GET_COMPANY_LIST_SUCCESS',
  GET_COMPANY_LIST_ERROR: 'GET_COMPANY_LIST_ERROR',

  ADD_COMPANY_REQUEST: 'ADD_COMPANY_REQUEST',
  ADD_COMPANY_SUCCESS: 'ADD_COMPANY_SUCCESS',
  ADD_COMPANY_ERROR: 'ADD_COMPANY_ERROR',

  GET_COMPANY_ITEM_REQUEST: 'GET_COMPANY_ITEM_REQUEST',
  GET_COMPANY_ITEM_SUCCESS: 'GET_COMPANY_ITEM_SUCCESS',
  GET_COMPANY_ITEM_ERROR: 'GET_COMPANY_ITEM_ERROR',

  UPDATE_COMPANY_REQUEST: 'UPDATE_COMPANY_REQUEST',
  UPDATE_COMPANY_SUCCESS: 'UPDATE_COMPANY_SUCCESS',
  UPDATE_COMPANY_ERROR: 'UPDATE_COMPANY_ERROR',

  DELETE_COMPANY_REQUEST: 'DELETE_COMPANY_REQUEST',
  DELETE_COMPANY_SUCCESS: 'DELETE_COMPANY_SUCCESS',
  DELETE_COMPANY_ERROR: 'DELETE_COMPANY_ERROR',

  GET_COMPANY_ACTIVE_REQUEST: 'GET_COMPANY_ACTIVE_REQUEST',
  GET_COMPANY_ACTIVE_SUCCESS: 'GET_COMPANY_ACTIVE_SUCCESS',
  GET_COMPANY_ACTIVE_ERROR: 'GET_COMPANY_ACTIVE_ERROR',

  UPDATE_COMPANY_QUERY_PARAMS: 'UPDATE_COMPANY_QUERY_PARAMS'
};
export default CompanyTypes;
